const en: Record<string, string> = {
  'common.return': 'Return',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.create': 'Create',
  'common.update': 'Update',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.archive': 'Archive',
  'common.restore': 'Restore',
  'common.close': 'Close',
  'common.filter': 'Filter',
  'common.loading': 'Loading...',
  'common.error': 'Error:',
  'common.success': 'Success!',
  'common.noData': 'No data found',
  'common.none': 'None',
  'common.home': 'Home',
  'common.admin': 'Admin',
  'common.installApp': 'Install app',
  'common.installAppIOSHint':
    'Tap the Share button in Safari, then "Add to Home Screen" to install this app.',
  'common.installAppGenericHint':
    'Use your browser\'s menu and look for "Add to Home Screen" or "Install app".',
  'common.created': 'Created',
  'common.actions': 'Actions',
  'common.name': 'Name',
  'common.confirm': 'Confirm',
  'common.project': 'Project',
  'common.saving': 'Saving...',
  'common.previousVersion': 'Previous version',
  'common.nextVersion': 'Next version',
  'common.viewingVersionNumber': 'Viewing version {{number}} of {{total}}',
  'common.createdBy': 'Created',
  'common.updatedBy': 'Updated',
  'common.forceOnDashboard': 'Force on Dashboard',
  'common.removeDate': 'Remove date',

  'iconPicker.searchPlaceholder': 'Search icons...',
  'iconPicker.noResults': 'No matching icon',
  'iconPicker.section.general': 'General',
  'iconPicker.section.tasks': 'Tasks & tracking',
  'iconPicker.section.calendar': 'Calendar & time',
  'iconPicker.section.documents': 'Documents & files',
  'iconPicker.section.media': 'Media & music',
  'iconPicker.section.people': 'Communication & people',
  'iconPicker.section.groceries': 'Groceries',

  'auth.signIn': 'Sign in to your account',
  'auth.magicLinkHint': "We'll send you a magic link to sign in",
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'user@example.com',
  'auth.sendMagicLink': 'Send the magic link',
  'auth.sending': 'Sending...',
  'auth.checkEmail': 'Check your email ({{email}}) for the sign-in link!',
  'auth.verifying': 'Verifying your magic link...',
  'auth.invalidLink': 'Invalid verification link',
  'auth.verificationError': 'An error occurred during verification',
  'auth.requestNewLink': 'Request a new magic link',
  'auth.emailNotFound': 'No account found for this email address.',
  'auth.sessionEndedReason': 'You were signed out: {{reason}}',
  'auth.sessionEndedTechnical': 'Technical detail: {{detail}}',

  'status.active': 'Active',
  'status.pending': 'Pending',
  'status.archived': 'Archived',

  'roles.Admin': 'Admin',
  'roles.Advanced user': 'Advanced user',
  'roles.User': 'User',
  'roles.noRoles': 'No roles assigned',

  'profile.title': 'Profile',
  'profile.personalInfo': 'Personal Information',
  'profile.accountInfo': 'Account Information',
  'profile.firstName': 'First Name:',
  'profile.lastName': 'Last Name:',
  'profile.gender': 'Gender:',
  'profile.documentId': 'Document ID:',
  'profile.login': 'Login:',
  'profile.email': 'Email:',
  'profile.roles': 'Roles:',
  'profile.logout': 'Logout',
  'profile.close': 'Close',
  'profile.language': 'Language',
  'profile.languageLabel': 'Display language',
  'profile.toolbarPlacement': 'Actions toolbar',
  'profile.toolbarPlacementLabel': 'Where should quick action icons show up?',
  'profile.toolbarPlacementOff': 'Hidden (menu only)',
  'profile.toolbarPlacementHeader': 'In the header',
  'profile.toolbarPlacementFooter': 'In the footer',
  'profile.represents': 'Represents',
  'profile.representsPerson': 'Represented Person',
  'profile.representsNone': 'No representation assigned',

  'admin.people': 'People',
  'admin.peopleSubtitle': 'Manage users, persons and their relationships',
  'admin.people.usersTab': 'Users',
  'admin.people.personsTab': 'Persons',
  'admin.people.representsTab': 'Represents',
  'admin.people.sendMagicLink': 'Send Link',
  'admin.people.generateMagicLink': 'Get Link',
  'admin.people.magicLinkSent': 'Magic link sent to {{email}}',
  'admin.people.magicLinkError': 'Failed to process magic link',
  'admin.people.magicLinkFor': 'Magic link for {{email}}',
  'admin.people.magicLinkWarning':
    'This link gives direct access to the account. Share it securely and only with the intended user.',
  'admin.people.copyLink': 'Copy Link',
  'admin.people.copied': 'Copied!',
  'admin.people.sendNotification': 'Send notification',
  'admin.editUser': 'Edit User',
  'admin.userNotFound': 'User not found',
  'admin.editTribe': 'Edit Tribe',
  'admin.tribeNotFound': 'Tribe not found',
  'admin.tribeInfo': 'Tribe information',
  'admin.users': 'Users',
  'admin.usersSubtitle': 'Manage user accounts and roles',
  'admin.persons': 'Persons',
  'admin.columnPersons': 'Members',
  'admin.filterByPerson': 'Filter by person',
  'admin.allPersons': 'All persons',
  'admin.noTribeMembers': 'No members yet',
  'admin.personsSubtitle': 'Manage persons',
  'admin.authorization': 'Authorization',
  'admin.authorizationSubtitle': 'Manage roles and permissions',
  'admin.authorization.rolesTab': 'Roles',
  'admin.authorization.permissionsTab': 'Permissions',
  'admin.roles': 'Roles',
  'admin.rolesSubtitle': 'Manage roles and permissions',
  'admin.permissions': 'Permissions',
  'admin.permissionsSubtitle': 'Manage permissions',
  'admin.positions': 'Positions',
  'admin.positionsSubtitle': 'Manage positions',
  'admin.represents': 'Represents',
  'admin.representsSubtitle': 'Manage user–person representations',
  'admin.tribesProjects': 'Tribes & Projects',
  'admin.tribes': 'Tribes',
  'admin.tribesSubtitle': 'Manage tribes',
  'admin.projects': 'Projects',
  'admin.projectsSubtitle': 'Manage projects',
  'admin.documents': 'Documents',
  'admin.documentsSubtitle': 'Manage documents and content',
  'admin.monitoring': 'Monitoring',
  'admin.monitoringSubtitle': 'Recent changes across all entities',
  'admin.mails.nav': 'Mails',
  'admin.mails.title': 'Mails',
  'admin.mails.subtitle': 'Outgoing mails and their delivery status',
  'admin.mails.mailType': 'Mail type',
  'admin.mails.subject': 'Subject',
  'admin.mails.mailStatus': 'Mail status',
  'admin.mails.allMailStatuses': 'All mail statuses',
  'mail_status.sent': 'Sent',
  'mail_status.not_sent': 'Not sent',
  'admin.mails.plannedAt': 'Planned at',
  'admin.mails.sentAt': 'Sent at',
  'admin.mails.recipients': 'Recipients',
  'admin.mails.noRecipients': 'No recipients',
  'admin.mails.content': 'Content',
  'admin.mails.noMails': 'No mails found for the current filters',
  'admin.monitoringHours': 'Show changes in the last',
  'admin.monitoringHoursUnit': 'hours',
  'monitoring.entity': 'Entity',
  'monitoring.id': 'ID',
  'monitoring.summary': 'Summary',
  'monitoring.createdAt': 'Created At',
  'monitoring.createdBy': 'Created By',
  'monitoring.updatedAt': 'Updated At',
  'monitoring.updatedBy': 'Updated By',
  'monitoring.status': 'Status',
  'monitoring.noChanges': 'No changes in this time window',
  'monitoring.filterByUser': 'User',
  'monitoring.filterByUserPlaceholder': 'user@example.com',
  'monitoring.filterByStatus': 'Status',
  'monitoring.allStatuses': 'All statuses',
  'monitoring.allUsers': 'All users',
  'monitoring.revisions.link': 'Revisions',
  'monitoring.revisions.title': 'Document Revisions',
  'monitoring.revisions.documentId': 'Document ID',
  'monitoring.revisions.list': 'Revisions',
  'monitoring.revisions.none': 'No revisions recorded for this document yet.',
  'monitoring.revisions.selectOne': 'Select a revision from the list.',
  'monitoring.revisions.loadError': 'Failed to load revisions.',
  'monitoring.revisions.older': 'Older',
  'monitoring.revisions.newer': 'Newer',
  'monitoring.revisions.current': 'Current',
  'admin.app': 'App',
  'admin.addUser': 'User',
  'admin.addPerson': 'Person',
  'admin.addRole': 'Role',
  'admin.addPermission': 'Permission',
  'admin.addPosition': 'Add Position',
  'admin.addRepresents': 'Add Represents',
  'admin.tribe': 'Tribe',
  'admin.addTribe': 'Add Tribe',
  'admin.addProject': 'Add Project',
  'admin.addDocument': 'Document',
  'admin.deleteSelectedUsers': 'Delete Selected Users',
  'admin.deleteSelectedPersons': 'Delete Selected Persons',
  'admin.deleteSelectedRoles': 'Delete Selected Roles',
  'admin.deleteSelectedPermissions': 'Delete Selected Permissions',
  'admin.deleteSelectedPositions': 'Delete Selected Positions',
  'admin.deleteSelectedRepresents': 'Delete Selected Represents',
  'admin.deleteSelectedTribes': 'Delete Selected Tribes',
  'admin.deleteSelectedProjects': 'Delete Selected Projects',
  'admin.deleteSelectedDocuments': 'Delete Selected Documents',
  'admin.deleteUser': 'Delete User',
  'admin.deletePerson': 'Delete Person',
  'admin.deleteRole': 'Delete Role',
  'admin.deletePermission': 'Delete Permission',
  'admin.deletePosition': 'Delete Position',
  'admin.deleteRepresents': 'Delete Represents',
  'admin.deleteTribe': 'Delete Tribe',
  'admin.deleteProject': 'Delete Project',
  'admin.deleteDocument': 'Delete Document',
  'admin.confirmDeleteSelected':
    'Are you sure you want to delete {{count}} item(s)?',
  'admin.confirmDeleteUser': 'Are you sure you want to delete {{login}}?',
  'admin.confirmDeletePerson': 'Are you sure you want to delete {{name}}?',
  'admin.confirmDeleteNamed': 'Are you sure you want to delete "{{name}}"?',
  'admin.confirmDeletePosition':
    'Are you sure you want to delete this position?',
  'admin.confirmDeleteRepresents':
    'Are you sure you want to delete this represents?',
  'admin.confirmDeleteDocument':
    'Are you sure you want to delete this document?',
  'admin.deleteSelected': 'Selected ({{count}})',
  'admin.searchLoginEmail': 'Search by login or email...',
  'admin.searchNameGenderDate': 'Search by name, gender, date...',
  'admin.searchNameDesc': 'Search by name or description...',
  'admin.searchName': 'Search by name...',
  'admin.searchContent': 'Search by content...',
  'admin.searchPositionType': 'Search by position type...',
  'admin.searchRepresents': 'Search by user or person...',
  'admin.columnUser': 'User',
  'admin.columnRoles': 'Roles',
  'admin.columnPermissions': 'Permissions',
  'admin.columnDocument': 'Document',
  'admin.columnTribe': 'Tribe',
  'admin.columnPosition': 'Position',
  'admin.columnPerson': 'Person',
  'admin.columnContentSummary': 'Content summary',
  'admin.columnAttachments': 'Attachments',
  'admin.attached': '✓ Attached',
  'admin.none': 'None',
  'admin.files': '{{count}} file(s)',
  'admin.foundResults': '{{count}} result(s)',
  'admin.genderMale': 'Male',
  'admin.genderFemale': 'Female',
  'admin.genderOther': 'Other',
  'admin.genderPreferNot': 'Prefer not to say',
  'admin.columnProject': 'Project',
  'admin.config': 'Configuration',
  'admin.configSubtitle': 'Manage runtime configuration values',
  'admin.config.key': 'Key',
  'admin.config.value': 'Value',
  'admin.config.description': 'Description',
  'admin.config.descriptionPlaceholder': 'What this setting controls...',
  'admin.config.addEntry': 'Add Entry',
  'admin.config.entry': 'Entry',
  'admin.notifications': 'Notifications',
  'admin.notifications.title': 'Notifications',
  'admin.notifications.subtitle': 'Send notifications to users',
  'admin.notifications.searchPlaceholder': 'Search users…',
  'admin.notifications.name': 'Name',
  'admin.notifications.email': 'Email',
  'admin.notifications.sendAction': 'Send notification',
  'admin.notifications.modalTitle': 'Send notification to {{name}}',
  'admin.notifications.messagePlaceholder': 'Enter your message…',
  'admin.notifications.send': 'Send',
  'admin.notifications.success': 'Notification queued for {{name}}',
  'admin.notifications.error': 'Failed to send notification',
  'admin.notifications.noResults': 'No users found. Type to search.',
  'admin.notifications.history': 'History',
  'admin.notifications.historyEmpty': 'No notifications sent yet.',
  'admin.notifications.historyRecipient': 'Recipient',
  'admin.notifications.historyMessage': 'Message',
  'admin.notifications.historyStatus': 'Status',
  'admin.notifications.historyScheduledFor': 'Scheduled for',
  'admin.notifications.historyDate': 'Date',
  'admin.notifications.status.planned': 'Queued',
  'admin.notifications.status.sent': 'Sent',
  'admin.notifications.status.failed': 'Failed',

  'validation.errorOccurred': 'An error occurred. Please try again.',

  'search.title': 'Search',
  'search.subtitle': 'Search through documents you have access to.',
  'search.placeholder': 'Search...',
  'search.empty': 'No results found for your query.',
  'search.highlightBanner': 'Showing result for: {{token}}',
  'search.removeHighlight': 'Highlight',

  'footer.allRightsReserved': '© {{year}} Modern Tribes. All rights reserved.',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.help': 'Help',

  'files.attachments': 'Attachments',
  'files.attachFiles': 'Attach Files',
  'files.uploading': 'Uploading...',
  'files.maxSize': 'Max {{maxFiles}} files, {{maxFileSize}}MB each',
  'files.maxFilesError': 'Maximum {{maxFiles}} files allowed',
  'files.fileSizeError': 'File {{filename}} exceeds {{maxFileSize}}MB limit',
  'files.uploadFailed': 'Upload failed',

  'labels.edit': 'label',
  'labels.delete': 'label',
  'labels.moveUp': 'Move up',
  'labels.moveDown': 'Move down',
  'labels.manage': 'Manage labels',
  'labels.none': 'No labels yet',
  'labels.newLabelPlaceholder': 'New label name',
  'labels.createLabel': 'Create label',
  'labels.confirmDelete': 'Delete "{{name}}"?',
  'labels.confirmDeleteInUse': 'Delete "{{name}}"? Used by {{count}} item(s).',

  'layout.toolbarConfigure': 'Configure toolbar',
  'layout.toolbarConfigureDirect': 'Direct',
  'layout.toolbarConfigureInMenu': 'In menu',

  'theme.selectTheme': 'Theme',

  'calendar.allDay': 'All day',
  'calendar.midnight': 'Midnight',
  'calendar.noItemsDay': 'Nothing on this day.',
  'calendar.noItemsWeek': 'Nothing this week.',

  'about.title': 'About',
  'about.subtitle':
    'Modern Tribes — a lightweight tool for organising the groups you belong to.',
  'about.sourceCode': 'Source code',
  'about.stack': 'Stack',
  'about.backendStack': 'Backend',
  'about.frontendStack': 'Frontend',
  'about.features': 'Features',
  'about.platform': 'Platform',
  'about.platformCore': 'Core',
  'about.platformFunctions': 'Functions',
  'about.platformTools': 'Tools',
  'about.subPackages': 'Sub-packages',
  'about.application': 'Application modules',

  'install.title': 'Install Modern Tribes',
  'install.subtitle': 'Add the app to your home screen for the best experience',
  'install.ios.title': 'Install on iPhone / iPad',
  'install.ios.safariRequired': 'Open in Safari first',
  'install.ios.safariRequiredDesc':
    'This page must be opened in Safari to install the app. Tap the sharing icon in your browser and choose "Open in Safari".',
  'install.ios.step1': 'Tap the Share button',
  'install.ios.step1desc':
    'The share icon is at the bottom of the Safari toolbar (arrow pointing up)',
  'install.ios.step2': 'Tap "Add to Home Screen"',
  'install.ios.step2desc':
    'Scroll down in the share sheet to find this option',
  'install.ios.step3': 'Tap "Add"',
  'install.ios.step3desc': 'Confirm by tapping Add in the top right corner',
  'install.android.title': 'Install on Android',
  'install.android.inAppBrowserTitle': 'Open in Chrome first',
  'install.android.inAppBrowserDesc':
    "You're in an app browser (e.g. Gmail). Tap the menu and choose \"Open in Chrome\" to install.",
  'install.android.openInChrome1': 'Tap the menu in your browser',
  'install.android.openInChrome1desc':
    'Look for ⋮ or a share icon in the top-right corner',
  'install.android.openInChrome2': 'Tap "Open in Chrome"',
  'install.android.openInChrome2desc': 'Or "Open in browser" — choose Chrome',
  'install.android.openInChrome3': 'Install from Chrome',
  'install.android.openInChrome3desc':
    'Once in Chrome, tap the Install button that appears here',
  'install.android.installButton': 'Install the app',
  'install.android.installing': 'Installing…',
  'install.android.manualTitle': 'Or install manually via Chrome:',
  'install.android.manual1': 'Open the Chrome menu',
  'install.android.manual1desc':
    'Tap the three-dot menu (⋮) in the top right corner',
  'install.android.manual2': 'Tap "Install app"',
  'install.android.manual2desc':
    'Or "Add to Home screen" on older versions of Chrome',
  'install.android.manual3': 'Confirm installation',
  'install.android.manual3desc':
    'Tap "Install" to add the app to your home screen',
  'install.android.apkTitle': 'Download the app directly',
  'install.android.apkDesc':
    'No Chrome required — download the APK and install it directly.',
  'install.android.apkButton': 'Download APK',
  'install.android.apkWarning':
    'You may need to allow installation from unknown sources in Android Settings → Apps → Special app access.',
  'install.desktop.title': 'Open on your phone',
  'install.desktop.desc':
    'Visit this address on your Android or iPhone to install the app:',
  'install.version.upToDate': 'You are up to date (version {{version}})',
  'install.version.updateAvailable': 'Update available: version {{version}}',
  'install.version.updateDesc': 'A new version of the app is available. Download the APK to upgrade.',
  'install.version.backToApp': 'Back to the app',
  'notifications.deniedBanner.message':
    'Notifications are blocked. To re-enable them, open Chrome → tap the lock icon next to the address bar → Site settings → Notifications → Allow.',
  'notifications.deniedBanner.dismiss': 'Dismiss',
};

export default en;
